import { useRouteError, isRouteErrorResponse } from 'react-router-dom'

export default function ErrorPage() {
  const error = useRouteError()

  return (
    <div className='min-h-screen flex items-center justify-center bg-gray-50'>
      <div className='max-w-md w-full bg-white shadow-lg rounded-lg p-6'>
        <div className='text-center'>
          <h1 className='text-6xl font-bold text-gray-900 mb-4'>Oops!</h1>
          <p className='text-xl text-gray-600 mb-4'>
            Sorry, an unexpected error has occurred.
          </p>
          <p className='text-gray-500'>
            <i>
              {isRouteErrorResponse(error)
                ? error.statusText || error.status
                : 'Unknown error'}
            </i>
          </p>
          <button
            onClick={() => (window.location.href = '/')}
            className='mt-6 btn-primary'
          >
            Go Home
          </button>
        </div>
      </div>
    </div>
  )
}
